import formatStateroomsForRequest from './formatters/formatStateroomsForRequest';

const getRateOptionRulesKey = ({
  itineraryId,
  rateOptionCode,
  pastPassengerNumber,
  cruiseItinerary,
  roomIndex,
}) => {
  let cruiseItineraryId = itineraryId;
  let cruiseRateOptionCode = rateOptionCode;
  let pastPassenger = pastPassengerNumber;

  const cabins = cruiseItinerary && cruiseItinerary.cabins.filter((c) => c);
  if (cruiseItinerary && cruiseItinerary.itineraryDetail) {
    cruiseItineraryId = cruiseItinerary.itineraryDetail.itineraryId;
    const selectedCabin = cabins.find((c) => c.roomIndex === roomIndex);
    if (selectedCabin) {
      if (selectedCabin.selectedRateOption) {
        cruiseRateOptionCode = selectedCabin.selectedRateOption.rateOptionCode;
      }
      if (selectedCabin && selectedCabin.searchInput) {
        pastPassenger = formatStateroomsForRequest(
          selectedCabin.searchInput,
          cruiseItinerary.itineraryDetail.cruiseLine.cruiseLineId,
        ).pastPassengerNumber;
      }
    }
  }

  if (cruiseItineraryId && cruiseRateOptionCode) {
    return `${cruiseItineraryId}-${cruiseRateOptionCode}-${roomIndex || 0}-${pastPassenger || ''}`;
  }
  return null;
};

export default getRateOptionRulesKey;
